module.exports = __webpack_public_path__ + "img/XRP-alt.762d0c5b.svg";